export const ACCESS_TOKEN = 'access_token';
export const ACTIVITY_REF = 'activity_ref';
export const ID_TOKEN = 'id_token';
export const SECURED_ID_TOKEN = 'secured_id_token';
